import * as React from 'react';
import { CaretDownOutlined } from '@ant-design/icons';
import { Cascader } from 'antd';
import { CascaderProps, BaseOptionType, DefaultOptionType } from 'antd/lib/cascader';
import './index.less';

export type NiCascaderPropsInfo<OptionType extends DefaultOptionType | BaseOptionType = DefaultOptionType> = CascaderProps<OptionType> & {};

export interface NiCascaderStateInfo {
  expanded: boolean;
}

export class NiCascader<OptionType extends DefaultOptionType | BaseOptionType = DefaultOptionType> extends React.Component<
  NiCascaderPropsInfo<OptionType>,
  NiCascaderStateInfo
> {
  constructor(props: NiCascaderPropsInfo<OptionType>) {
    super(props);
    this.state = { expanded: false };
  }

  render() {
    return (
      <Cascader
        onDropdownVisibleChange={(popupVisible: boolean) => {
          this.setState({ expanded: popupVisible });
        }}
        suffixIcon={
          <CaretDownOutlined
            className={
              this.state.expanded ? 'ant-cascader-picker-arrow-expand' : ''
            } />
        }
        {...this.props}
        className={'ni-cascader ' + this.props.className}
      />
    );
  }
}
